import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

require('../../../../icons/checkcircleo.svg');

@Component({
  template: require('./collapse.html'),
  name: 'wc-collapse'
})
export class Collapse extends Vue {
  @Prop()
  borderless: boolean;
}



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/collapse/collapse.ts